import { AsyncPipe, NgClass, NgIf } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Observable } from 'rxjs';
import { MenuOption, OptionGroup } from '../../models/menu-option';
import { GroupedMultiselectSearchMenuComponent } from '../grouped-multiselect-search-menu/grouped-multiselect-search-menu.component';

@Component({
    selector: 'app-multiselect',
    templateUrl: './multiselect.component.html',
    styleUrls: ['./multiselect.component.scss'],
    imports: [
        NgIf,
        NgClass,
        FormsModule,
        ReactiveFormsModule,
        GroupedMultiselectSearchMenuComponent,
        AsyncPipe,
    ]
})
export class MultiselectComponent {
  @Input() disabled: boolean = false;
  @Input() selectedOptions: MenuOption[] = [];
  @Input() inputId: string = '';
  @Input() label: string = '';
  @Input() name: string = '';
  @Input() error?: string = '';
  @Input() placeholder?: string = '';
  @Input() optionGroup$: Observable<OptionGroup[]> | undefined;
  @Input() disabledGroup$: Observable<OptionGroup[]> | undefined;
  @Input() disabledLabel: string = 'Disabled Options';

  @Output() optionsChange = new EventEmitter<MenuOption[]>();

  onOptionsChange(options: MenuOption[]) {
    this.selectedOptions = options;
    this.optionsChange.emit(this.selectedOptions);
  }

  getSelectedOptions(): MenuOption[] {
    return this.selectedOptions;
  }
}
